import { useEffect, useState } from "react";
import { http } from "../lib/api";

const REFRESH_INTERVAL_MS = 60_000; // every 60s (server also caches 60s)

/**
 * Live MFSMAI token price + 24h change + market cap.
 * Returns null while loading, then a price object. Auto-refreshes every 60s.
 */
export function useTokenPrice() {
  const [price, setPrice] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchPrice = async () => {
      try {
        const { data } = await http.get("/token/price");
        if (!cancelled) setPrice(data);
      } catch {
        // Keep last known value on transient network errors.
      }
    };
    fetchPrice();
    const t = setInterval(fetchPrice, REFRESH_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, []);

  return price;
}
